import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import appStoreBadge from '../../assets/images/footer/app-store-badge.svg';
import googlePlayBadge from '../../assets/images/footer/google-play-badge.svg';

const MobileApps = ({ isAndroid, isIos }) => {
  const appStoreClassNames = cx(
    'common-footer__app-store-link',
    { 'hide-mobile': isAndroid },
    { 'full-width-mobile': isIos }
  );
  const googlePlayClassNames = cx(
    'common-footer__google-play-link',
    { 'hide-mobile': isIos },
    { 'full-width-mobile': isAndroid }
  );

  return (
    <div className="common-footer__mobile-apps">
      <h3 className="common-footer__mobile-apps-title">Download the Zola App</h3>
      <ul className="common-footer__mobile-apps-items">
        <li className="common-footer__mobile-apps-item">
          <a
            className={appStoreClassNames}
            href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStoreBadge} alt="Download On The App Store" />
          </a>
        </li>
        <li className="common-footer__mobile-apps-item">
          <a
            className={googlePlayClassNames}
            href="https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={googlePlayBadge} alt="Get It On Google Play" />
          </a>
        </li>
      </ul>
    </div>
  );
};

MobileApps.defaultProps = {
  isAndroid: false,
  isIos: false,
};

MobileApps.propTypes = {
  isAndroid: PropTypes.bool,
  isIos: PropTypes.bool,
};

export default MobileApps;
